import React, { Component } from 'react'
import ChatBot from 'react-simple-chatbot'
import Phoenix from './Phoenix'
import botAvatar from '../../images/avatar/smallpilot.png'
import { ThemeProvider } from 'styled-components'

const theme = {
  background: '#f5f8fb',
  fontFamily: 'Roboto Slab',
  headerBgColor: '#323c5a',
  headerFontColor: '#fff',
  headerFontSize: '15px',
  botBubbleColor: 'darkslateblue',
  botFontColor: '#faffff',
  userBubbleColor: '#fff',
  userFontColor: '#4a4a4a',
};

class ReactBot extends Component {
  state = {
    messages: [],
    enableFloating: false,
    open: true,
    phoenix: {
      text: {
        text: ['original test']
      }
    }
  }

  render() {
    const mySteps = [
      {
        id: '1',
        message: 'Hi how can I help you?',
        trigger: 'search'
      },
      {
        id: 'search',
        user: true,
        trigger: '3',
      },
      {
        id: '3',
        component: <Phoenix/>,
        //waitAction: true,
        //message: this.state.phoenix.text[0],
        trigger: 'search'
      },
    ]
    return (
      <ThemeProvider theme={theme}>
      <ChatBot
        headerTitle="CyberChat"
        opened={this.state.open}
        toggleFloating={() => { this.setState( (prev) => ({
          open: !prev.open
        })) }}
        hideHeader={!this.props.enableFloating}
        handleEnd={this.handleEnd}
        botDelay={2000}
        userDelay={500}
        botAvatar={botAvatar}
        hideUserAvatar={true}
        steps={mySteps}
        floating={this.props.enableFloating}
      />
      </ThemeProvider>
    )
  }
}

export default ReactBot
